// @flow

import * as React from 'react';

import { ProductIcon } from '@gandi/cart';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { mapTags, useTranslator } from '@gandi/translate';
import { Base, Text } from '@gandi/ui';

import styles from './DomainIntro.scss';

export type OwnProps = {
  application?: ApplicationSummary,
};

export type Props = {
  ...OwnProps,
};

function DomainIntro({ application }: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <>
      <Base
        className={styles.title}
        flex
        flexAlignItemsCenter
        flexJustifyCenter
      >
        <ProductIcon className={styles.icon} type="domain" />
        <Base align="center" margin="none" tagName="h2">
          {__('Now, choose your free domain')}
        </Base>
      </Base>
      <Base align="center" margin="none" tagName="p">
        {mapTags(
          __(
            'To run your [[app:Web Hosting]], [[boldText:you need a domain name]], which will be the address of your website.',
          ),
          ({ app, boldText }) => ({
            app: application?.name_label || app,
            boldText: <Text weight="semibold">{boldText}</Text>,
          }),
        )}
      </Base>
      <Base align="center" color="light" margin="none" tagName="p">
        {__('The domain remains free when you renew.')}
      </Base>
    </>
  );
}

export default DomainIntro;
